require('./src/filters.module.js');
require('./src/config/blocks.filters.config.js');
require('./src/filters/boolean.start.filter.js');
require('./src/filters/boolean.yes.no.filter.js');
require('./src/filters/get.checkbox.icon.class.filter.js');
require('./src/filters/phone.number.filter.js');
require('./src/filters/reduce.if.more.than.filter.js');
require('./src/filters/string.join.filter.js');
require('./src/filters/truncate.ellipsis.filter.js');